"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SankeyMenuConfigurationNodesTooltip = void 0;
const react_1 = __importStar(require("react"));
const react_2 = require("@chakra-ui/react");
const SankeyUtils_1 = require("./SankeyUtils");
const SankeyMenuConfigurationNodesTooltip = (applicationContext, dict_variable_elements_selected, menu_for_modal) => {
    const { t } = applicationContext;
    const { multi_selected_nodes } = dict_variable_elements_selected;
    const [forceUpdate, setForceUpdate] = (0, react_1.useState)(false);
    const content = react_1.default.createElement(react_2.Box, { layerStyle: 'menuconfigpanel_grid' },
        react_1.default.createElement(react_2.Box, { as: 'span', layerStyle: 'menuconfigpanel_part_title_1' }, t('Noeud.IB')),
        react_1.default.createElement(SankeyUtils_1.OSTooltip, { label: t('Noeud.tooltips.IB') },
            react_1.default.createElement(react_2.Textarea, { rows: 10, value: multi_selected_nodes.current.length > 0 && multi_selected_nodes.current[0].tooltip_text ?
                    multi_selected_nodes.current[0].tooltip_text :
                    '', onChange: (evt) => {
                    multi_selected_nodes.current.map(node => node.tooltip_text = evt.target.value);
                    setForceUpdate(!forceUpdate);
                } })));
    return menu_for_modal ?
        [
            content
        ] : [
        react_1.default.createElement(react_2.Tab, null,
            react_1.default.createElement(react_2.Box, { layerStyle: 'submenuconfig_tab' }, t('Noeud.tabs.infos'))),
        react_1.default.createElement(react_2.TabPanel, null, content)
    ];
};
exports.SankeyMenuConfigurationNodesTooltip = SankeyMenuConfigurationNodesTooltip;
